import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';



@Component({
  selector: 'app-device-size-indicator',
  templateUrl: './size-indicator.component.html',
  styleUrl: './size-indicator.component.scss',
  imports: [CommonModule, MatIconModule]
})
export class AppDeviseSizeIndicatorComponent {
  @Input() size!: string;


}
